interface SpacerProps {
  height: number;
}

const Spacer = ({ height }: SpacerProps) => <div style={{ height }} className="spacer" />;

export default Spacer;
